import { memo, useCallback } from 'react';

import { AssetVersionControlRow } from '~/components/ShareModal/components/VersionsAndDownloadingSection/AssetVersionControlRow';
import { useShowcaseModal } from '~/components/ShowcaseModal/ShowcaseModalContext';

/** Create-mode smart leaf: asset version control segmented row. Writes draft state, no per-change analytics. */
export const CreateShowcaseSettingsVersionControlRow = memo(() => {
  const { shortUrlProps, isSaving, updateAssetPermission } = useShowcaseModal();

  const handleVersionControlChange = useCallback(
    (canViewAllVersions: boolean) => updateAssetPermission('canViewAllVersions', canViewAllVersions),
    [updateAssetPermission],
  );

  return (
    <AssetVersionControlRow
      variant="multi-asset"
      canViewAllVersions={shortUrlProps.permissions.asset.canViewAllVersions}
      data-testid="ASSET_VERSION_CONTROL_SEGMENTED_CONTROL"
      isLoading={isSaving}
      onChange={handleVersionControlChange}
    />
  );
});

CreateShowcaseSettingsVersionControlRow.displayName = 'CreateShowcaseSettingsVersionControlRow';
